<div class="d-flex align-items-center">
  <div class="icon d-flex justify-content-center">
    <i [className]="data.iconClass"></i>
  </div>
  <div class="content mr-15 ml-15 d-flex w-100p">
    <span class="bold align-self-center">{{data.lableText}} -</span><div class="ml-5" [innerHtml]="data.text"></div>
  </div>
</div>
